import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { ListaServiciosItemBuscador } from "../ServiciosBuscador/ListaServiciosItemBuscador";
import { getServiciosCerca } from "../../utils/servicios/serviciosCercaUtils";
import { handleFavoriteServicioAction } from "../../utils/favoritos/favoritosUtils";
import CustomSectionCard from "../CustomSectionCard/CustomSectionCard";
import SkeletonCard from "../SkeletonCard/SkeletonCard";
import "./ServiciosCerca.scss";

const ServiciosCerca = () => {
  const [servicios, setServicios] = useState([]);
  const [loading, setLoading] = useState(true); // 🔥 Estado de carga inicial
  const [meta, setMeta] = useState({ fueraDeRango: false, sinTiendas: false });
  const { userLocation, userData, userFavorites } = useUser();
  const navigate = useNavigate();
  const userFavoritesRef = useRef(userFavorites);

  useEffect(() => {
    if (!userLocation) return undefined;
    // Si la ubicación cambia mientras se consulta, se ignora la respuesta anterior
    let vigente = true;
    setLoading(true);
    getServiciosCerca(userLocation, userFavoritesRef.current, (data) => {
      if (!vigente) return;
      setServicios(data);
      setLoading(false);
    }, (m) => vigente && setMeta(m));
    return () => {
      vigente = false;
    };
  }, [userLocation]);

  // Los favoritos solo actualizan el corazón; no vuelven a consultar los servicios
  useEffect(() => {
    userFavoritesRef.current = userFavorites;
    const favoritos = (userFavorites && userFavorites.servicios) || [];
    setServicios((prev) => prev.map((s) => ({ ...s, isFavorite: favoritos.includes(s.id) })));
  }, [userFavorites]);
  
  const handleFavoriteToggle = async (productId, isFavorite) => {
    // Actualización optimista del estado local para feedback inmediato
    const updatedServices = servicios.map((s) => 
      s.id === productId ? { ...s, isFavorite: !isFavorite } : s
    );
    setServicios(updatedServices);

    const action = isFavorite ? "remove" : "add";
    handleFavoriteServicioAction(productId, action, userData);
  };

  return (
    <div className="servicios-cerca-section">
      <CustomSectionCard
        title="Servicios cerca de ti"
        subtitle="Explora los servicios disponibles a tu alrededor"
      >
        {!loading && meta.sinTiendas && (
          <Typography.Text type="secondary">Aún no hay tiendas con ubicación registrada cerca de ti.</Typography.Text>
        )}
        {!loading && meta.fueraDeRango && (
          <Typography.Text type="secondary">No hay tiendas a menos de 50 km. Te mostramos las más cercanas.</Typography.Text>
        )}
        <Row
          gutter={[
            { xs: 8, sm: 16, md: 24 }, // Ajustado a 8 para consistencia con productos
            { xs: 12, sm: 24, md: 32 },
          ]}
          justify="start"
          className="services-grid"
        >
          {loading ? (
            // 🔥 Mientras carga, mostramos las siluetas (Skeleton)
            [1, 2, 3, 4, 5, 6].map((key) => (
              <Col xs={12} sm={12} md={8} lg={8} xl={6} key={key}>
                <SkeletonCard />
              </Col>
            ))
          ) : (
            // Una vez cargado, mostramos los servicios reales
            servicios.map((servicio) => (
              <Col xs={12} sm={12} md={8} lg={8} xl={6} key={servicio.id}>
                <ListaServiciosItemBuscador
                  servicio={servicio}
                  addToCart={() => navigate(`/servicio/${servicio.id}`)}
                  favorite={() =>
                    handleFavoriteToggle(servicio.id, servicio.isFavorite)
                  }
                  isFavorite={servicio.isFavorite}
                />
              </Col>
            ))
          )}
        </Row>
      </CustomSectionCard>
    </div>
  );
};

export default ServiciosCerca;